import { render, staticRenderFns } from "./MTableRowDropdownWrapper.vue?vue&type=template&id=05c0f0c2"
import script from "./MTableRowDropdownWrapper.vue?vue&type=script&lang=js"
export * from "./MTableRowDropdownWrapper.vue?vue&type=script&lang=js"
import style0 from "./MTableRowDropdownWrapper.vue?vue&type=style&index=0&id=05c0f0c2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports